import Experiments from 'types/Experiments';
import useSelector from './useSelector';

export default function useExperiments() {
  return useSelector((state: { experiments: Experiments }) => state.experiments || {});
}
